import {
  Moon,
  Sunrise,
  ClipboardList,
  BookOpen,
  NotebookPen,
  Heart,
  CalendarDays,
  Target,
  Sparkles,
  Wallet,
  Users,
  ShieldCheck,
} from "lucide-react";

// --- Daily Practice (hero cards) ---
export const practiceCards = [
  { id: "inventory", title: "Inventory", desc: "Review the day", icon: Moon },
  { id: "gratitude", title: "Gratitude", desc: "Add today's list", icon: Sunrise },
  { id: "spot-check", title: "Spot Check", desc: "Capture a resentment", icon: ClipboardList },
  { id: "readings", title: "Readings", desc: "Open today's reading", icon: BookOpen },
];

// --- Today's counters ---
export const counters = [
  {
    id: "primary",
    heading: "Today",
    tags: [
      { code: "CA", note: "clean" },
      { code: "AA", note: "sober" },
      { code: "NA", note: "clean" },
      { code: "GA", note: "free from gambling" },
    ],
    days: 1118,
    since: "1 Jun 2023",
    progress: 77,
    nextMilestone: "4 years",
    daysToGo: 343,
    lastMilestone: "3 years",
  },
  {
    id: "alanon",
    heading: "Al-Anon",
    tags: [{ code: "AL-ANON", note: "in the program" }],
    days: 1149,
    since: "1 May 2023",
    progress: 79,
    nextMilestone: "4 years",
    daysToGo: 312,
    lastMilestone: "3 years",
  },
];

// --- Tools ---
export const toolsDaily = [
  { id: "journal", title: "Journal", desc: "One honest line about today", icon: NotebookPen },
  { id: "nightly", title: "Nightly Inventory", desc: "A gentle look back at the day", icon: Moon },
  { id: "gratitude2", title: "Gratitude", desc: "Note what you're grateful for", icon: Sunrise },
  { id: "spot2", title: "Spot Check", desc: "Capture a resentment now", icon: ClipboardList },
  { id: "readings2", title: "Readings", desc: "A thought for the day", icon: BookOpen },
];

export const toolsExplore = [
  { id: "prayers", title: "Prayers", icon: Heart },
  { id: "meetings", title: "Meetings", icon: CalendarDays },
  { id: "milestones", title: "Milestones", icon: Target },
  { id: "insights", title: "Insights", icon: Sparkles },
];

export const toolsFellowship = [
  { id: "financial", title: "Financial Inventory", tag: "GA", icon: Wallet },
  { id: "prg", title: "Pressure Relief Group", tag: "GA / DA", icon: Users },
  { id: "gsr", title: "Gambling Self-Reflection", tag: "GA", icon: ShieldCheck },
];

export const steps = Array.from({ length: 12 }, (_, i) => i + 1);
